import { requestGet, requestPost, requestPut, requestDel } from '@/api/request'

/**
 * 注册
 * @param { string } email - 邮箱
 * @param { string } phone 手机号码
 * @param { string } globe 区号
 * @param { string } code -  验证码
 * @param { string } password -  密码
 * @returns
 */
export const registerUser = (data) => {
  return requestPost({
    url: `/user/v1/register/`,
    data
  })
}

/**
 * Code 登录
 * @param { string } email - 邮箱
 * @param { string } phone 手机号码
 * @param { string } globe 区号
 * @param { string } code -  验证码
 * @returns
 */
export const codeLogin = (data) => {
  return requestPost({
    url: `/user/v1/code-login/`,
    data
  })
}

/**
 * Password 登录
 * @param { string } email - 邮箱
 * @param { string } code -  验证码 *
 * @param { string } password - 密码 *
 * @param { string } phone - 手机号码
 * @param { string } globe - 区号
 * @returns
 */
export const passwordLogin = (data) => {
  return requestPost({
    url: `/user/v1/pwd-login/`,
    data
  })
}

/**
 * Apple 登录
 * @param { string } code
 * @returns
 */
export const appleLogin = (data) => {
  return requestPost({
    url: `/user/v1/apple-login/`,
    data
  })
}

/**
 * Google 登录
 * @param { string } code
 * @returns
 */
export const googleLogin = (data) => {
  return requestPost({
    url: `/user/v1/google-login/`,
    data
  })
}

/**
 * Line 登录
 * @param { string } code
 * @returns
 */
export const lineLogin = (data) => {
  return requestPost({
    url: `/user/v1/line-login/`,
    data
  })
}

/**
 * 退出登录
 */
export const logoutUser = () => {
  return requestPost({ url: `/user/v1/logout/` })
}

/**
 * 修改密码
 * @param { string } email - 邮箱
 * @param { string } code - 验证码
 * @param { string } password - 密码
 * @param { string } confirm_password - 确认密码
 * @param { string } phone - 手机号码
 * @param { string } globe - 区号
 * @returns
 */
export const modifyPassword = (data) => {
  return requestPost({
    url: `/user/v1/alterpwd/`,
    data
  })
}

/**
 * 绑定手机号码
 * @param { string } code - 验证码
 * @param { string } phone - 手机号码
 * @param { string } globe - 区号
 * @returns
 */
export const bindPhone = (data) => {
  return requestPost({
    url: `/user/v1/bind-phone/`,
    data
  })
}

/**
 * 绑定邮箱
 * @param { string } email - 邮箱
 * @param { string } code - 验证码
 * @returns
 */
export const bindEmail = (data) => {
  return requestPost({
    url: `/user/v1/bind-email/`,
    data
  })
}

/**
 * 获取用户信息
 */
export const getUserDetail = () => {
  return requestGet({ url: `/user/v1/user-detail/` })
}

/**
 * 修改用户信息
 * @param { string } username - 名字
 * @returns
 */
export const modifyUserDetail = (data) => {
  return requestPut({
    url: `/user/v1/user-detail/`,
    data
  })
}

/**
 * 上传头像
 * 限制图片大小最大为 5M
 * @param { file } headshot_file - 图片(普通图片格式)
 * @returns
 */
export const uploadHeadshot = (data) => {
  return requestPost({
    url: `/user/v1/upload-headshot/`,
    data
  })
}

/**
 * 注销
 */
export const unsubscribe = () => {
  return requestDel(`/user/v1/user-detail/`)
}

/**
 * 用户-发送邮箱验证码
 * @param { string } email 邮箱
 * @returns
 */
export const sendEmailCode = (data) => {
  return requestPost({
    url: `/user/v1/send-mail-code/`,
    data
  })
}

/**
 * 用户-发送手机验证码
 * @param { string } phone 手机号码
 * @param { string } globe 区号
 * @returns
 */
export const sendSMSCode = (data) => {
  return requestPost({
    url: `/user/v1/send-sms/`,
    data
  })
}
